import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";

import { buildOutboxCampaignHref } from "@/pages/Private/pages/Messages/pages/Outbox/buildOutboxCampaignHref";
import { OutboxStatusTab } from "@/pages/Private/pages/Messages/pages/Outbox/outboxStatusTabs";

/** The Outbox tabs a campaign row links to, in the order they are shown. */
const CAMPAIGN_OUTBOX_TABS = [OutboxStatusTab.SCHEDULED, OutboxStatusTab.IN_PROGRESS] as const;

interface CampaignOutboxLinksProps {
	listId: number;
	listName?: string | null;
	campaignUuid: string;
}

/**
 * "Scheduled" and "In progress" next to a campaign's lead count (PREC-4291): each opens the Outbox
 * on that tab, narrowed to this list and this campaign. The labels are the Outbox tabs' own, so the
 * link names the place it goes to.
 */
export const CampaignOutboxLinks: FunctionComponent<CampaignOutboxLinksProps> = ({
	listId,
	listName,
	campaignUuid,
}) => {
	const { t } = useTranslation();

	return (
		<span className="inline-flex items-center gap-2">
			{CAMPAIGN_OUTBOX_TABS.map((tab) => {
				const label = t(`outbox.statusTabs.${tab}`);

				return (
					<Link
						key={tab}
						className="cursor-pointer whitespace-nowrap text-xs font-medium text-text-meta underline underline-offset-2 hover:text-brand-light"
						title={t("list.campaignRollup.outboxLinkHint", { tab: label })}
						to={buildOutboxCampaignHref({ listId, listName, campaignUuid, tab })}
						// The row opens the campaign builder on click; the link goes to the Outbox instead. The
						// second click of a double click is dropped, so one Back returns to the table.
						onClick={(e) => {
							e.stopPropagation();

							if (e.detail > 1) {
								e.preventDefault();
							}
						}}
					>
						{label}
					</Link>
				);
			})}
		</span>
	);
};
